import React from 'react'

import './img.less'

export default function NewsImg(props) {
    const img = require(`../../assets/news/img/${props.img}`)

    return <img className="news_img" src={img.default}  alt="" />
}
